import { useRouter } from "next/router";
import queryString from "query-string";
import { useCallback, useState } from "react";
import Loading from "~/components/common/parts/loading/Loading";
import { Page as Component } from "~/components/specifics/todos/index/Page";
import { useCompanyDealTodos } from "~/hooks/useCompanyDealTodos";
import { useCompanyStoreSettings } from "~/hooks/useCompanyStoreSettings";
import { useCompanyVendors } from "~/hooks/useCompanyVendors";
import useItandiAccount from "~/hooks/useItandiAccount";
import { useEnabledStaffs } from "~/hooks/useStaffs";
import type { CompanyDealTodoSearchCondition } from "~/models/CompanyDealTodo";
import { PATH } from "~/pages/todos";
import { normalizeSearchCondition } from "~/utils/CompanyDealTodoSearchConditionUtil";

export const Page: React.FC = () => {
	const router = useRouter();
	const [searchCondition, setSearchCondition] =
		useState<CompanyDealTodoSearchCondition>(
			normalizeSearchCondition(router.query)
		);
	const companyDealTodos = useCompanyDealTodos(searchCondition);
	const staffs = useEnabledStaffs().data;
	const { data: companyVendors } = useCompanyVendors().index();
	const { data: companyStoreSettings } = useCompanyStoreSettings().index();
	const { data: account } = useItandiAccount().currentAccount();
	const { data } = companyDealTodos;

	const updateSearchCondition = useCallback(
		(condition: CompanyDealTodoSearchCondition) => {
			setSearchCondition((prev) => {
				const newCondition = normalizeSearchCondition({
					...prev,
					...condition,
					...(!("page" in condition) ? { page: 1 } : {})
				});

				// URLだけを書き換える
				window.history.pushState(
					"",
					"",
					`${PATH}?${queryString.stringify(newCondition, {
						arrayFormat: "bracket"
					})}`
				);
				return newCondition;
			});
		},
		[]
	);

	if (
		data === null ||
		staffs === null ||
		companyVendors === null ||
		account === null ||
		companyStoreSettings === null
	)
		return <Loading isLoading />;

	return (
		<Component
			account={account}
			companyStoreSettings={companyStoreSettings}
			companyTodos={data.objects}
			companyVendors={companyVendors}
			currentPageNum={searchCondition.page ?? 1}
			onSearchConditionChange={updateSearchCondition}
			searchCondition={searchCondition}
			staffs={staffs}
			totalItems={data.count}
		/>
	);
};
